import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthLayout } from '@/layouts/auth';
import { PortalLayout } from '@/layouts/portal';
import { PortalLogin } from '@/pages/portal/PortalLogin';
import { PortalForgotPassword } from '@/pages/portal/PortalForgotPassword';
import { PortalSetPassword } from '@/pages/portal/PortalSetPassword';
import { PortalAccount } from '@/pages/portal/PortalAccount';
import { PortalMatters } from '@/pages/portal/PortalMatters';
import { PortalMatter } from '@/pages/portal/PortalMatter';
import { PortalProvider } from './PortalProvider';
import { RequirePortalSession } from './RequirePortalSession';

/**
 * The client portal, route /portal/* (OL-192).
 *
 * Outside RequireAuth and the staff MainLayout on purpose: a guest is not a
 * user, has no staff token, and must never land in the staff shell.
 */
const PortalPage = () => (
  <PortalProvider>
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="login" element={<PortalLogin />} />
        <Route path="forgot-password" element={<PortalForgotPassword />} />
        <Route path="set-password/:token" element={<PortalSetPassword />} />
      </Route>

      <Route element={<RequirePortalSession />}>
        <Route element={<PortalLayout />}>
          <Route index element={<PortalMatters />} />
          <Route path="matters/:matterId" element={<PortalMatter />} />
          <Route path="account" element={<PortalAccount />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/portal" replace />} />
    </Routes>
  </PortalProvider>
);

export { PortalPage };
